// extracted by mini-css-extract-plugin
export default {"container":"addRuleModal_container__FFI1H","queryLoading":"addRuleModal_queryLoading__QZLHj","queryError":"addRuleModal_queryError__+AaoW"};